export const movies = [
  {
    id: "1",
    title: "午夜霓虹",
    titleEn: "Midnight Neon",
    year: 2024,
    rating: 8.1,
    genres: ["剧情", "爱情"],
    region: "美国",
    director: "伊桑·科尔",
    cast: "奥利维亚·里德、马克·唐纳、索菲亚·林",
    duration: "118分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20artwork%20of%20a%20rainy%20neon-lit%20city%20street%20at%20night%20with%20an%20elegant%20solitary%20silhouette%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20minimalist%20moody%20dramatic%20lighting%2C%20abstract%20artistic%2C%20no%20text&width=600&height=900&seq=film-cover-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20rainy%20neon-lit%20metropolitan%20street%20at%20night%20with%20reflections%20on%20wet%20asphalt%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20atmospheric%20moody%20dramatic%20lighting%2C%20no%20text&width=1600&height=900&seq=film-back-01&orientation=landscape",
    summary: "霓虹之下，两个陌生人的一夜相遇，悄然改写了彼此的命运。",
    plot: "在永不停歇的都市里，夜班的出租车司机与一位神秘的旅人偶然相遇。霓虹灯影之下，他们用一整夜的时间分享各自从未说出口的秘密。\n\n影片以细腻的都市观察与克制的镜头语言，勾勒出现代人在喧嚣中孤独取暖的处境。随着黎明渐近，两人不得不面对现实与情感之间的抉择。\n\n《午夜霓虹》凭借扎实的剧本与出色的氛围营造，被多家影评机构评为年度最具质感的都市情感作品。",
    tags: ["都市情感", "黑色电影", "年度口碑"],
    featured: true,
  },
  {
    id: "2",
    title: "欲望迷宫",
    titleEn: "Maze of Desire",
    year: 2023,
    rating: 7.4,
    genres: ["爱情", "惊悚"],
    region: "法国",
    director: "克莱尔·杜邦",
    cast: "艾拉·冯丹、卢卡·莫雷、朱丽叶·贝尔",
    duration: "106分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20artwork%20of%20a%20shadowy%20mirrored%20maze%20corridor%20with%20soft%20crimson%20and%20deep%20blue%20light%2C%20mysterious%20elegant%20mood%2C%20minimalist%20dramatic%20lighting%2C%20abstract%20artistic%2C%20no%20text&width=600&height=900&seq=film-cover-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20interior%20of%20a%20mirrored%20maze%20with%20soft%20crimson%20and%20deep%20blue%20lighting%2C%20mysterious%20elegant%20atmosphere%2C%20abstract%20artistic%2C%20no%20text&width=1600&height=900&seq=film-back-02&orientation=landscape",
    summary: "一场精心安排的聚会，逐渐演变成无法抽身的心理博弈。",
    plot: "一位年轻的画廊策展人受邀参加一场只有六个人的私人晚宴。随着夜色加深，宾客之间的关系变得微妙而危险。\n\n导演以迷宫般精巧的叙事结构，将欲望、误解与试探层层叠合，让观众与主角一同在真伪难辨的线索中寻找出口。\n\n影片的配乐与美术设计尤为出色，营造出一种令人着迷又不安的独特氛围。",
    tags: ["心理悬疑", "欧陆文艺", "氛围感"],
    featured: false,
  },
  {
    id: "3",
    title: "巴黎未眠",
    titleEn: "Paris Awake",
    year: 2024,
    rating: 7.9,
    genres: ["爱情", "剧情"],
    region: "法国",
    director: "安托万·勒费弗",
    cast: "卡米耶·洛朗、诺亚·施密特、蕾雅·马松",
    duration: "124分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20artwork%20of%20a%20lone%20figure%20by%20a%20balcony%20overlooking%20rooftops%20at%20dawn%2C%20soft%20rose%20and%20deep%20blue%20gradient%20sky%2C%20minimalist%20romantic%20mood%2C%20abstract%20artistic%2C%20no%20text&width=600&height=900&seq=film-cover-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20view%20of%20parisian%20rooftops%20at%20dawn%20with%20soft%20rose%20and%20deep%20blue%20sky%2C%20romantic%20atmospheric%20lighting%2C%20no%20text&width=1600&height=900&seq=film-back-03&orientation=landscape",
    summary: "在浪漫之都，一段跨越阶级与理想的情感悄然生长。",
    plot: "一位初到巴黎的建筑系学生，与一位在旧书店打工的女孩因一场误会相识。两人在城市的日常里彼此了解、彼此改变。\n\n影片以舒缓的节奏与温暖的对话，呈现年轻人在理想与现实之间摇摆的心境，也描绘了巴黎街角那些容易被忽略的风景。\n\n《巴黎未眠》被评论界称赞为近年最真诚的欧陆爱情电影之一。",
    tags: ["欧陆爱情", "都市生活", "治愈系"],
    featured: true,
  },
  {
    id: "4",
    title: "暗涌之城",
    titleEn: "City of Undercurrents",
    year: 2023,
    rating: 7.6,
    genres: ["惊悚", "动作"],
    region: "英国",
    director: "西蒙·布莱克",
    cast: "丹尼尔·哈特、伊芙·摩根、科林·沃德",
    duration: "112分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20artwork%20of%20a%20foggy%20harbor%20city%20at%20night%20with%20sharp%20teal%20and%20amber%20highlights%2C%20tense%20thriller%20mood%2C%20minimalist%20dramatic%20lighting%2C%20abstract%20artistic%2C%20no%20text&width=600&height=900&seq=film-cover-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20foggy%20harbor%20city%20skyline%20at%20night%20with%20amber%20highlights%2C%20tense%20atmospheric%20thriller%20mood%2C%20no%20text&width=1600&height=900&seq=film-back-04&orientation=landscape",
    summary: "一桩看似普通的失踪案，牵出港口城市盘根错节的暗流。",
    plot: "一名经验丰富的调查记者回到阔别多年的家乡，追查一桩被迅速结案的失踪案。线索将他一步步引向城市光鲜表面之下的另一面。\n\n影片以冷静的镜头与紧绷的节奏，探讨了真相、责任与代价之间的复杂关系，动作场面的调度也干净利落。\n\n作为导演西蒙·布莱克的第二部长片，本作展现出成熟的类型掌控力。",
    tags: ["犯罪悬疑", "硬核剧情", "英伦质感"],
    featured: false,
  },
  {
    id: "5",
    title: "红唇疑云",
    titleEn: "Crimson Riddle",
    year: 2022,
    rating: 6.8,
    genres: ["惊悚", "爱情"],
    region: "意大利",
    director: "马泰奥·里奇",
    cast: "吉娅·卡塔尼、保罗·贝尔蒂、安娜·莫罗",
    duration: "99分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20artwork%20with%20an%20elegant%20lipstick%20mark%20and%20dramatic%20crimson%20light%20on%20dark%20velvet%20background%2C%20mysterious%20classic%20mood%2C%20minimalist%20artistic%2C%20no%20text&width=600&height=900&seq=film-cover-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20interior%20of%20an%20old%20italian%20villa%20with%20dramatic%20crimson%20lighting%20and%20dark%20velvet%20textures%2C%20mysterious%20elegant%20mood%2C%20no%20text&width=1600&height=900&seq=film-back-05&orientation=landscape",
    summary: "一场上流社会的宴会，因一封匿名信而暗流汹涌。",
    plot: "在意大利乡间的一座古老别墅里，一场精心筹备的宴会即将开始。然而一封匿名信的出现在宾客之间引发了连锁反应。\n\n影片向经典悬疑片致敬，以优雅的场面调度与层层反转的谜题，展现人性在猜忌中的微妙变化。\n\n适合喜爱传统推理叙事的观众细细品味。",
    tags: ["古典悬疑", "群像戏", "反转"],
    featured: false,
  },
  {
    id: "6",
    title: "罗马假日之后",
    titleEn: "After Rome",
    year: 2024,
    rating: 7.2,
    genres: ["爱情"],
    region: "意大利",
    director: "马泰奥·里奇",
    cast: "吉娅·卡塔尼、卢卡·里瓦、艾琳娜·菲奥",
    duration: "108分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20artwork%20of%20a%20sunlit%20roman%20street%20with%20warm%20terracotta%20tones%20and%20a%20bicycle%20silhouette%2C%20romantic%20nostalgic%20mood%2C%20minimalist%20artistic%2C%20no%20text&width=600&height=900&seq=film-cover-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20sunlit%20roman%20piazza%20with%20warm%20terracotta%20and%20amber%20tones%2C%20romantic%20nostalgic%20atmosphere%2C%20no%20text&width=1600&height=900&seq=film-back-06&orientation=landscape",
    summary: "一段被时间搁置的感情，在多年后的罗马重新被拾起。",
    plot: "曾在罗马短暂相遇的两个人，因各自的选择而分道扬镳。多年以后，一次偶然的重逢让旧日记忆重新浮现。\n\n影片以温暖明亮的色调与克制的叙事，讲述成年人面对遗憾与释怀时的温柔。\n\n《罗马假日之后》是一部关于时间、选择与珍惜的作品。",
    tags: ["意式浪漫", "重逢", "温暖"],
    featured: false,
  },
  {
    id: "7",
    title: "情迷巴塞罗那",
    titleEn: "Barcelona Rhapsody",
    year: 2023,
    rating: 7.8,
    genres: ["爱情", "剧情"],
    region: "西班牙",
    director: "卡洛斯·纳瓦罗",
    cast: "露西亚·桑斯、马科斯·奥尔特加、艾娃·罗梅罗",
    duration: "115分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20artwork%20of%20colorful%20gaudi%20mosaic%20architecture%20with%20warm%20golden%20and%20deep%20blue%20tones%2C%20vibrant%20romantic%20mood%2C%20minimalist%20artistic%2C%20no%20text&width=600&height=900&seq=film-cover-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20colorful%20barcelona%20architecture%20at%20golden%20hour%20with%20warm%20amber%20tones%2C%20vibrant%20romantic%20atmosphere%2C%20no%20text&width=1600&height=900&seq=film-back-07&orientation=landscape",
    summary: "在地中海阳光下，三个人的夏天，写就一段自由的狂想曲。",
    plot: "一群来自不同国家的年轻人，在巴塞罗那合租一栋老房子，度过了一个充满音乐、争执与成长的夏天。\n\n影片以自由流动的叙事与明快的节奏，捕捉青春特有的热烈与迷茫，也描绘了友情与爱情之间模糊的边界。\n\n《情迷巴塞罗那》被赞为一部充满生命力的群像电影。",
    tags: ["青春群像", "地中海", "自由"],
    featured: true,
  },
  {
    id: "8",
    title: "危险关系",
    titleEn: "Dangerous Liaison",
    year: 2025,
    rating: 8.3,
    genres: ["剧情", "爱情"],
    region: "法国",
    director: "克莱尔·杜邦",
    cast: "艾拉·冯丹、诺亚·施密特、朱丽叶·贝尔",
    duration: "131分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20artwork%20of%20two%20elegant%20silhouettes%20facing%20each%20other%20against%20a%20deep%20navy%20background%20with%20a%20warm%20amber%20rim%20light%2C%20tense%20romantic%20mood%2C%20minimalist%20artistic%2C%20no%20text&width=600&height=900&seq=film-cover-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20elegant%20dimly%20lit%20ballroom%20with%20deep%20navy%20and%20warm%20amber%20lighting%2C%20tense%20romantic%20mood%2C%20no%20text&width=1600&height=900&seq=film-back-08&orientation=landscape",
    summary: "一场关于情感与权力的博弈，优雅而危险。",
    plot: "一位擅长洞察人心的社交名流，与一位不苟言笑的年轻律师因一桩委托而相识。两人心照不宣地开始了一场没有规则的较量。\n\n影片改编自经典题材，以现代视角重新诠释情感与自尊的角力，台词锋利，表演张力十足。\n\n《危险关系》在多个影展获得好评，被认为是该类型近年最出色的作品之一。",
    tags: ["年度新高分", "情感博弈", "法国电影"],
    featured: true,
  },
  {
    id: "9",
    title: "夜色温柔",
    titleEn: "Tender Is the Night",
    year: 2024,
    rating: 7.5,
    genres: ["剧情"],
    region: "美国",
    director: "伊桑·科尔",
    cast: "索菲亚·林、马克·唐纳、艾米·惠特",
    duration: "121分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20artwork%20of%20a%20quiet%20moonlit%20seaside%20town%20with%20soft%20silver%20and%20deep%20blue%20tones%2C%20melancholic%20tender%20mood%2C%20minimalist%20artistic%2C%20no%20text&width=600&height=900&seq=film-cover-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20quiet%20seaside%20town%20at%20night%20under%20moonlight%20with%20soft%20silver%20and%20deep%20blue%20tones%2C%20melancholic%20tender%20mood%2C%20no%20text&width=1600&height=900&seq=film-back-09&orientation=landscape",
    summary: "一间海边旅馆，收留了一个不愿提起过去的旅人。",
    plot: "一位作家为了寻找灵感，住进了一间即将歇业的海边旅馆。旅馆里形形色色的住客，让他重新思考写作与生活的意义。\n\n影片节奏舒缓，对白富有文学气息，在海浪与夜色的衬托下讲述关于孤独与和解的故事。\n\n《夜色温柔》是一部适合静心观看的文艺剧情片。",
    tags: ["文艺剧情", "海边小镇", "治愈"],
    featured: false,
  },
  {
    id: "10",
    title: "曼哈顿迷雾",
    titleEn: "Manhattan Mist",
    year: 2023,
    rating: 7.0,
    genres: ["惊悚", "动作"],
    region: "美国",
    director: "西蒙·布莱克",
    cast: "丹尼尔·哈特、奥利维亚·里德、科林·沃德",
    duration: "105分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20artwork%20of%20a%20misty%20manhattan%20skyline%20with%20sharp%20amber%20windows%20and%20cool%20navy%20fog%2C%20tense%20thriller%20mood%2C%20minimalist%20artistic%2C%20no%20text&width=600&height=900&seq=film-cover-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20the%20manhattan%20skyline%20shrouded%20in%20fog%20at%20night%20with%20amber%20window%20lights%2C%20tense%20atmospheric%20thriller%20mood%2C%20no%20text&width=1600&height=900&seq=film-back-10&orientation=landscape",
    summary: "整座城市陷入浓雾，而真相也一同被遮蔽。",
    plot: "一场罕见的大雾让曼哈顿陷入半瘫痪状态。一名警探在追查一起连环案件时，发现所有线索都指向同一个被掩盖的真相。\n\n影片充分利用都市空间的压迫感，将悬疑与动作元素紧密结合，节奏紧凑。\n\n《曼哈顿迷雾》是一部完成度很高的都市惊悚片。",
    tags: ["都市惊悚", "追凶", "高概念"],
    featured: false,
  },
  {
    id: "11",
    title: "蓝色海岸",
    titleEn: "Côte Bleue",
    year: 2022,
    rating: 6.9,
    genres: ["爱情"],
    region: "法国",
    director: "安托万·勒费弗",
    cast: "卡米耶·洛朗、蕾雅·马松、雨果·佩兰",
    duration: "102分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20artwork%20of%20a%20sunny%20mediterranean%20coastline%20with%20turquoise%20water%20and%20warm%20sand%20tones%2C%20romantic%20summer%20mood%2C%20minimalist%20artistic%2C%20no%20text&width=600&height=900&seq=film-cover-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20sunny%20mediterranean%20coastline%20with%20turquoise%20water%20and%20warm%20golden%20light%2C%20romantic%20summer%20atmosphere%2C%20no%20text&width=1600&height=900&seq=film-back-11&orientation=landscape",
    summary: "一个短暂的夏天，一次关于勇气与告白的海边假期。",
    plot: "为了逃避城市生活的疲惫，一位设计师来到南法海岸度假，却意外结识了一群热情的当地居民。\n\n影片色调明亮，节奏轻快，用细腻的日常细节描绘出一段充满阳光味道的夏日恋曲。\n\n《蓝色海岸》是一部轻松愉悦的浪漫小品。",
    tags: ["夏日恋曲", "轻松", "南法"],
    featured: false,
  },
  {
    id: "12",
    title: "最后的探戈",
    titleEn: "Last Tango",
    year: 2025,
    rating: 8.0,
    genres: ["剧情", "爱情"],
    region: "西班牙",
    director: "卡洛斯·纳瓦罗",
    cast: "露西亚·桑斯、马科斯·奥尔特加、艾娃·罗梅罗",
    duration: "127分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20artwork%20of%20a%20pair%20of%20dancers%20in%20mid-tango%20silhouette%20under%20a%20warm%20spotlight%20on%20deep%20navy%20background%2C%20passionate%20elegant%20mood%2C%20minimalist%20artistic%2C%20no%20text&width=600&height=900&seq=film-cover-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20dimly%20lit%20dance%20hall%20with%20warm%20amber%20spotlights%20and%20deep%20navy%20shadows%2C%20passionate%20elegant%20mood%2C%20no%20text&width=1600&height=900&seq=film-back-12&orientation=landscape",
    summary: "一位老舞者决定，用最后一支探戈告别他深爱的舞台。",
    plot: "布宜诺斯艾利斯与马德里之间，一位年迈的探戈舞者筹备着他职业生涯的告别演出。过往的记忆随舞步一一浮现。\n\n影片将舞蹈、音乐与人生故事交织，情感饱满而不失克制，被影评人称为\"写给探戈的一封情书\"。\n\n《最后的探戈》是当年最具感染力的文艺剧情片之一。",
    tags: ["舞动人生", "年度期待", "文艺"],
    featured: true,
  },
];